import VueI18n from "vue-i18n";
import localeEn from "./en";
import localeEs from "./es";
import localeFr from "./fr";
import localeCa from "./ca";
import Vue from "vue";
import moment from "moment";

Vue.use(VueI18n);
let locale = "en";
switch (navigator.language.substring(0, 2)) {
  case "es":
    locale = "es";
    break;
  case "en":
    locale = "en";
    break;
  case "fr":
    locale = "fr";
    break;
  case "ca":
    locale = "ca";
    break;
}
const i18n = new VueI18n({
  locale, // set locale,
  messages: {
    en: localeEn,
    es: localeEs,
    fr: localeEn, //localeFr,
    ca: localeCa,
  },
});
moment.locale(locale);
export { i18n };
